<script>

import { Overlay } from '../../'

export default {
    name: 'RSI',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Relative Strength Index',
                preset: {
                    name: 'RSI $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1,
                        color: 'rgb(126, 87, 194)',
                        bandColor: '#aaa',
                        backColor: 'rgba(126, 87, 194, 0.1)',
                    }
                }
            }
        },
        use_for() { return ['RSI'] },
        calc() {
            return {
                props: {
                    length: { value: 14, def: 14, text: 'Length' }
                },
                conf: { renderer: 'Range' },
                update: `return rsi(close, length)[0]`
            }
        }
    }
}
</script>
